export function getHF4Homework(state, sessionId) {
  return state.getIn(['rootReducer', 'hf4Homework', sessionId]);
}



// WEBPACK FOOTER //
// ./data/HF4Homework/accessors.js